import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import {
    BrowserRouter as Router,
    Route,
    Switch,
} from 'react-router-dom'

import customTagStore from './store'
import Panel from '../../../../UniformComponents/Panel'
import Loader from '../Loader'
import CreateEdit from './CreateEdit'
import Search from './Search'
import CustomTagSearch from './CustomTagSearch'
import BenchmarksModal from './BenchmarksModal'

import './style.scss'

@observer
class customTag extends Component {
    constructor(props) {
        super(props)

        this.customTagStore = new customTagStore(props.store, props.customBenchmark)
        this.customTagStore.init()
    }

    componentDidMount() {
        const { store, customBenchmark } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'customTag',
                url: customBenchmark ? '/intranet/customBenchmark' : '/intranet/customTag',
                title: customBenchmark ? 'Custom Benchmark' : 'Custom Tag',
            },
        ]
    }

    render() {
        const { history: appHistory } = this.props
        const { customTagStore } = this
        const { isLoading } = customTagStore

        return (
            <Fragment>
                <Loader show={isLoading} />
                <Panel cssClass="customTag">
                    <Router>
                        <Switch>
                            <Route
                                path="/intranet/customTag/:customTagId"
                                render={({ match, history }) => (
                                    <CreateEdit
                                        store={this.customTagStore}
                                        id={match.params.customTagId}
                                        history={history}
                                        match={match}
                                    />
                                )}
                            />
                            <Route
                                path="/intranet/customTag"
                                render={({ match, history }) => (
                                    <CustomTagSearch
                                        store={this.customTagStore}
                                        appHistory={appHistory}
                                        history={history}
                                        match={match}
                                    />
                                )}
                            />
                            <Route
                                path="/intranet/customBenchmark/:customTagId"
                                render={({ match, history }) => (
                                    <CreateEdit
                                        store={this.customTagStore}
                                        id={match.params.customTagId}
                                        history={history}
                                        match={match}
                                    />
                                )}
                            />
                            <Route
                                path="/intranet/customBenchmark"
                                render={({ match, history }) => (
                                    <Search
                                        store={this.customTagStore}
                                        appHistory={appHistory}
                                        history={history}
                                        match={match}
                                    />
                                )}
                            />
                            <Route
                                render={() => (
                                    <div>not found certification</div>
                                )}
                            />
                        </Switch>
                    </Router>
                </Panel>
                <BenchmarksModal store={this.customTagStore} />
            </Fragment>
        )
    }
}

export default customTag
